// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"185":"2b03aaf5","272":"e5a2cd68","551":"ca1d4656","906":"677a750e"}[chunkId] + ".chunk.css";
};